export const TEST_ID = {
  jva: {
    modalTitle: "jva-modal-title",
  },
  component: {
    draggable_icon: "component-draggable-icon",
    cardSpinner: "card-spinner",
  },
  layout: {
    popoverSummaryTrigger: "layout-popover-summary-trigger",
    popoverSummarySelectedLanguage: "layout-popover-summary-selected-language",
    popoverSummaryLanguageOption: "layout-popover-summary-language-option",
    popoverSummaryLanguageMenuBack: "layout-popover-summary-language-menu-back",
    notificationButton: "notification-button",
    notificationAvatarLogo: "notification-logo-avatar",
    notificationMessageContainer: "notification-message-container",
  },
  courseDashboard: {
    buttonSeeClass: "course-dashboard-button-see-class",
  },
  session: {
    sessionCardButton: "session-card-button",
    videoSectionContainer: "session-video-container",
    readingSectionContainer: "session-reading-section-container",
    homeworkExamContainer: "session-homework-exam-container",
    nextSessionButton: "session-next-session-button",
    liveSessionContainer: "session-live-session-container",
    liveSessionZoomContainer: "sesion-live-zoom-session-container",
    liveSessionVideoContainer: "session-live-video-session-container",
    buttonGoToExam: "session-go-to-exam-button",
  },
  homeworkExam: {
    container: "homework-exam-container",
    questionContainer: "homework-exam-question-container",
    essayInput: "homework-exam-essay-input",
    nextQuestionButton: "homework-exam-next-question-button",
    numberNavigationButton: "-number-navigation-button",
    multipleChoiceInput: "homework-exam-multiple-choice-input",
    checkboxInput: "homework-exam-checkbox-input",
    uploadInput: "homework-exam-upload-input",
    uploadedInput: "homework-exam-uploaded-input",
    deleteUploadedButton: "homework-exam-delete-uploaded-button",
    forcedOptionInput: "homework-exam-forced-option-input",
    likert: "homework-exam-likert-input",
    likertQuestion: "homework-exam-likert-question",
    submit: "homework-exam-submit-button",
    submitConfirm: "homework-exam-submit-confirm",
  },
  dashboard: {
    menuToProfileDashboardButton: "my-profile-drop-down-option",
    headerTitle: "dashboard-header-title",
    emailVerificationModal: "dashboard-email-verification-modal",
    headerLogo: "dashboard-header-logo",
    sidebarContainer: "dashboard-sidebar-container",
  },
  HomepageDesktop: {
    dashboardButton: "dashboard-page-button-desktop",
    projectBasedInternshipMenu: "project-based-internship-menu",
    aboutPBI: "pbi-about",
  },
  talentHiring: {
    heroText: "talent-hiring-hero-text",
  },
  hiringDashboard: {
    disableOption: "hiring-dashboard-disable-option",
    matchRateSetting: "hiring-dashboard-match-rate-setting",
    blacklist: {
      importCsvButton: "blacklist-import-csv-button",
      importModal: "blacklist-import-modal",
      importFileField: "blacklist-import-file-field",
      importSubmitButton: "blacklist-import-submit-button",
      importTemplateLink: "blacklist-import-template-link",
      importResultSummary: "blacklist-import-result-summary",
      importInvalidRows: "blacklist-import-invalid-rows",
    },
    talentScoutingDashboard: {
      hiringProcessChart: {
        daysCategory: "hiring-dashboard-talent-scouting-hiring-process-chart-days-category",
        percentageCategory:
          "hiring-dashboard-talent-scouting-hiring-process-chart-percentage-category",
        chart: "hiring-dashboard-talent-scouting-hiring-process-chart",
        empty: "hiring-dashboard-talent-scouting-hiring-process-chart-empty",
      },
      applicantSources: "hiring-dashboard-talent-scouting-applicant-sources",
      latestApplicantsUpdate: "hiring-dashboard-talent-scouting-latest-applicants-update",
      viewAllLatestApplicantsUpdates:
        "hiring-dashboard-talent-scouting-view-all-latest-applicants-updates",
      viewTalentProfile: "hiring-dashboard-talent-scouting-view-talent-profile",
      summaryCard: "hiring-dashboard-talent-scouting-summary-card",
      jobVacancyFilter: "hiring-dashboard-talent-scouting-job-vacancy-filter",
      jobVacancyName: "hiring-dashboard-talent-scouting-job-vacancy-name",
    },
    tooltip: "hiring-dashboard-tooltip",
    callAdmin: "hiring-dashboard-call-admin",
    resetEditKolom: "hiring-dashboard-reset-edit-kolom",
    applyChangesSidebar: "hiring-dashboard-apply-changes-sidebar",
    searchEditKolomList: "hiring-dashboard-search-edit-column-list",
    editKolomListContainer: "hiring-dashboard-edit-column-list",
    editKolomChevron: "hiring-dashboard-edit-column-chevron",
    closeEditKolomDrawerButton: "hiring-dashboard-close-drawer-button",
    editKolomCheckboxes: "hiring-dashboard-edit-kolom-checkboxes",
    parentListEditKolomContainer: "hiring-dashboard-edit-kolom-parent-list-container",
    editKolomSidebar: "hiring-dashboard-edit-kolom-sidebar",
    editKolomButton: "hiring-dashboard-edit-kolom-button",
    searchRecruiter: "hiring-dashboard-search-recruiter",
    recruiterEmail: "hiring-dashboard-recruiter-email",
    recruiterCheckbox: "hiring-dashboard-recruiter-checkbox",
    vacancySetting: "vacancy-setting-dropdown",
    visibilitySetting: "visibility-setting-dropdown",
    editOption: "edit-dropdown-option",
    publishOption: "publish-dropdown-option",
    inviteRecruiterOption: "invite-recruiter-dropdown-option",
    deleteVacancyOption: "delete-vacancy-dropdown-option",
    vacancyName: "job-vacancy-card-name",
    vacancyState: "vacancy-state-chip",
    dashboardNavigation: "company-hiring-dashboard-navigation",
    openVacancyButton: "open-new-vacancy-button",
    welcomeBannerTagline: "hiring-dashboard-welcome-banner-tagline",
    manageVacanciesButton: "manage-vacancies-button",
    salaryRange: "job-vacancy-card-salary-range",
    addColumnButton: "hiring-dashboard-add-column-button",
    talentScoutingForm: {
      pipelineNameInput: "pipeline-name-input",
      undoDeletePipelineButton: "undo-delete-pipeline-button",
      deletePipelineButton: "delete-pipeline-button",
      assessmentDropdown: "assessment-dropdown",
      createInnitialAssessmentButton: "create-initial-assessment-button",
      reminderConfirmButton: "reminder-confirm-button",
      universityMajorMultiSelect: "university-major-multi-select",
      jobVacancyTypeDropdown: "job-vacancy-type-dropdown",
      jobVacancyTypeDropdownItem: "job-vacancy-type-dropdown-item",
      jobVacancyNameAutocomplete: "job-vacancy-name-autocomplete",
      jobTypeDropdown: "job-type-dropdown",
      jobTypeTooltip: "job-type-tooltip",
      jobRoleDropdown: "job-role-dropdown",
      jobGradeDropdown: "job-grade-dropdown",
      departmentDropdown: "department-dropdown",
      highCriteriaMultiSelect: "high-criteria-multi-select",
      lowCriteriaMultiSelect: "low-criteria-multi-select",
      educationLevelDropdown: "education-level-dropdown",
      workExperienceLevelDropdown: "work-experience-level-dropdown",
      industryCategoryDropdown: "industry-category-dropdown",
      workModeDropdown: "work-mode-dropdown",
      locationAutocomplete: "location-autocomplete",
      candidateQuotaTextField: "candidate-quota-text-field",
      homeEntityTextField: "home-entity-text-field",
      hostEntityTextField: "host-entity-text-field",
      candidateQualificationTextEditor: "candidate-qualification-text-editor",
      minimumSalaryTextField: "minimum-salary-text-field",
      maximumSalaryTextField: "maximum-salary-text-field",
      jobDescriptionTextEditor: "job-description-text-editor",
      saveFormButton: "save-form-button",
      jobApplicationSetting: "job-application-setting",
      addAdditionalQuestionButton: "add-additional-question-button",
      addAnotherAdditionalQuestionButton: "add-another-additional-question-button",
      additionalQuestionToggleMandatory: "additional-question-toggle-mandatory",
      additionalQuestionType: "additional-question-type",
      additionalQuestionName: "additional-question-name",
      additionalQuestionMultiAnswer: "additional-question-multi-answer",
      optionName: "option-name",
      addOption: "add-option",
    },
    tableCandidate: {
      candidateTableData: "candidate-table-data",
      candidateTableRow: "candidate-table-row",
      cvDigitalTitle: "cv-digital-title",
      viewProfileDetails: "view-profile-details",
    },
    hiringPipeline: {
      inviteTalentButton: "invite-talent-button",
      acceptTalentButton: "accept-talent-button",
      chooseNextProcess: "choose-next-process-dropdown",
      vacancyAssessmentWrapper: "job-vacancy-assessment-wrapper",
      documentUpload: "document-upload",
      uploadedFileAttachment: "uploaded-file-attachment",
    },
    bulkUpdateApplicants: {
      goToUpdateApplicantsButton: "go-to-update-applicants-button",
      helpButton: "update-applicants-help-button",
      importCsvButton: "import-csv-button",
      sortButton: "update-applicants-sort-button",
      emptyState: "update-applicants-empty-state",
      csvUploader: "update-applicants-csv-uploader",
      deliveryTimePicker: "update-applicants-delivery-time",
      submitFormButton: "update-applicants-submit-button",
      failedState: "update-applicants-failed",
      successState: "update-applicants-success",
      scheduledState: "update-applicants-scheduled",
      inProgressState: "update-applicants-inprogess",
      queuedState: "update-applicants-queued",
      otherState: "update-applicants-other",
      downloadTemplate: "update-applicants-download-template",
      downloadResult: "update-applicants-download-result",
    },
    aiInterview: {
      createTemplateButton: "ai-interview-create-template-button",
      templateNameInput: "ai-interview-template-name-input",
      templateDescriptionInput: "ai-interview-template-description-input",
      addQuestionButton: "ai-interview-add-question-button",
      questionInput: "ai-interview-question-input",
      questionDurationDropdown: "ai-interview-question-duration-dropdown",
      questionAspectDropdown: "ai-interview-question-aspect-dropdown",
      saveTemplateButton: "ai-interview-save-template-button",
      deleteQuestionButton: "ai-interview-delete-question-button",
    },
    customEmail: {
      breadcrumb: "custom-email-breadcrumb",
      templateCard: "custom-email-template-card",
      subjectField: "custom-email-subject-field",
      companyLogoField: "custom-email-company-logo-field",
      titleField: "custom-email-title-field",
      bodyField: "custom-email-body-field",
      footerCompanyLogoField: "custom-email-footer-company-logo-field",
      footerCompanyNameField: "custom-email-footer-company-name-field",
      footerLocationField: "custom-email-footer-location-field",
      footerLinkedinField: "custom-email-footer-linkedin-field",
      footerInstagramField: "custom-email-footer-instagram-field",
      footerWhatsappField: "custom-email-footer-whatsapp-field",
      preview: "custom-email-preview",
      cancelButton: "custom-email-cancel-button",
      saveButton: "custom-email-save-button",
    },
    assessment: {
      cardTitle: "hiring-dashboard-assessment-card-title",
      info: "hiring-dashboard-assessment-info",
      inviteTalentModal: "hiring-dashboard-assessment-invite-talent-modal",
      inviteTalent: "hiring-dashboard-assessment-invite-talent",
      inviteTalentCheckbox: "hiring-dashboard-assessment-invite-talent-checkbox",
      invitedTalentName: "hiring-dashboard-assessment-invited-talent-name",
      tabPanel: "hiring-dashboard-assessment-tab-panel",
    },
  },
  editProfile: {
    editProfileButton: "profile-edit-button",
    fullnameField: "profile-fullname-field",
    nikField: "profile-nik-field",
    radioButtonsContainer: "profile-radio-button-container",
    headlineField: "profile-headline-field",
    locationField: "profile-location-field",
    emailField: "profile-location-email-text-field",
    phoneField: "profile-location-phone-field",

    portfolioField: "profile-location-portfolio-field",
    linkedinField: "profile-location-linkedin-field",
    saveButton: "profile-save-button",
    deleteButton: "profile-delete-button",
    achievementModal: {
      nameField: "achievement-modal-name-field",
      issueField: "achievement-modal-issue-field",
      dateField: "achievement-modal-date-field",
      credentialField: "achievement-modal-credential-field",
      credentialUrlField: "achievement-modal-credential-url-field",
      competenciesField: "achievement-competencies-field",
    },
    educationModal: {
      degreeDropdown: "education-modal-degree-dropdown",
      schoolField: "education-modal-school-field",
      majorField: "education-modal-major-field",
      startDatePicker: "education-modal-start-date-picker",
      endDatePicker: "education-modal-end-date-picker",
      gpaField: "education-modal-gpa-field",
      certifNumberField: "education-modal-certif-number-field",
      ijazahField: "education-modal-ijazah-field",
      transcriptField: "education-modal-transcript-field",
      descriptionField: "education-modal-desc-field",
    },
    educationItem: {
      degreeField: "education-item-degree-field",
      schoolNameField: "education-item-school-name-field",
      majorNameField: "education-item-major-name-field",
      dateField: "education-item-date-field",
      endDateField: "education-item-end-date-field",
      scoreField: "education-item-score-field",
    },
    projectModal: {
      titleField: "project-modal-title-field",
      urlField: "project-modal-url-field",
      descField: "project-modal-desc-field",
      skillFields: "project-modal-skill-field",
    },
    experienceModal: {
      roleField: "experience-modal-role-field",
      employmentTypeField: "experience-modal-type-field",
      companyField: "experience-modal-name-field",
      industryField: "experience-modal-industry-field",
      stillWorkField: "experience-modal-still-work-field",
      startField: "experience-modal-start-field",
      endField: "experience-modal-end-field",
      descField: "experience-modal-desc-field",
      competenciesField: "experience-modal-competencies-field",
      exitField: "experience-modal-exit-reason-field",
    },
    additionalModal: {
      religionField: "additional-modal-religion-field",
      ethnicField: "additional-modal-ethnic-field",
      latestSalaryField: "additional-modal-latest-salary-field",
      birthDateField: "additional-modal-birthdate-field",
      minimumSalaryField: "additional-modal-min-salary-field",
      maximumSalaryField: "additional-modal-max-salary-field",
      aktaField: "additional-modal-akta-field",
      familyCardField: "additional-modal-family-card-field",
      preferredIndustryField: "additional-modal-preferred-industry-field",
      avoidedIndustryField: "additional-modal-avoided-industry-field",
      languageField: "additional-modal-language-field",
    },
  },
  prakerja: {
    resultVerificationText: "prakerja-success-verif-text",
    descriptionVerificationText: "prakerja-description-verif-text",
    callbackButton: "prakerja-callback-button",
    submitRedeemButton: "prakerja-submit-redeem-button",
    messageRedeem: "prakerja-message-redeem",
  },
  profile: {
    fullnameText: "profile-fullname-text",
    headlineText: "profile-headline-text",
    genderText: "profile-gender-text",
    locationText: "profile-location-text",
    linkedinText: "profile-linkedin-text",
    portfolioText: "profile-portfolio-text",
    phoneText: "profile-phone-text",
    buttonProfileUrl: "profile-button-url",
    previewUrl: "profile-preview-url",
    applicantHistory: "profile-applicant-history",
    skillProficiency: "profile-skill-proficiency",
    backToDashboardButton: "profile-back-to-dashboard",
  },
  loginRegister: {
    title: "login-register-form-title",
    successResetPassword: "success-reset-password",
    emailField: "login-register-email-text-field",
    passwordField: "login-register-password-text-field",
    confirmPasswordField: "login-register-confirm-password-field",
    submitButton: "login-register-submit-button",
    googleButton: "login-register-google-button",
    fullnameField: "login-register-full-name-text-field",
    forgotButton: "login-register-forgot-button",
    toggleButton: "login-register-toggle-button",
    resetPassword: "login-register-reset-password",
    createNewAccountUrl: "login-register-create-new-account-url",
    descAllScreenForm: "login-register-desc-all-screen-form",
  },
  biodataFulfillment: {
    container: "biodata-container-element",
    // Personal Data
    domicileField: "biodata-domicile-field",
    phoneField: "biodata-phone-field",
    portfolioField: "biodata-portfolio-field",
    linkedinField: "biodata-linkedin-field",
    //Experience Data
    companyNameField: "biodata-company-name-field",
    roleField: "biodata-role-field",
    roleTypeField: "biodata-role-type-field",
    isStillEmployedHere: "biodata-still-employed-here-checkbox",
    entryDate: "biodata-entry-date-field",
    // Last Ed
    lastEducationField: "biodata-last-education-field",
    schoolNameField: "biodata-school-name-field",
    majorField: "biodata-major-field",
    isStillStudyHere: "biodata-still-study-here-checkbox",
    studyStartDate: "biodata-study-start-date-field",
    // cta
    nextSectionFormButton: "biodata-next-section-form-button",
  },
  vixExplorePage: {
    vixListCards: "vix-card-list",
    searchPBITextField: "search-pbi-textfield",
  },
  vixDetailLandingPage: {
    modalFormRegisterVix: "modal-form-register-vix",
    vixInfoSourceRadioButton: "vix-info-source-options",
    agreementCheckbox: "agreement-checkbox",
    registerVixButton: "registerVix-button",
    continueRegisterModal: "continue-register-modal",
    container: "container-vix-detail-landing-page",
  },
  input: {
    fullNameField: "full-name-text-field",
    submit: "submit-button",
    phoneField: "phone-number-text-field",
    linkedinUrlField: "linkedin-url-text-field",
  },
  moduleSession: {
    container: "module-session-container-element",
  },
  myClassDashboard: {
    certificateContainer: "myclass-dashboard-certificate-container",
    certificateComponent: "myclass-dashboard-certificate-component",
    certificateComponentPreviewed: "myclass-dashboard-certificate-component-previewed",
    downloadCertificateButton: "myclass-dashboard-download-certificate-button-modal",
    downloadCertificateButtonPage: "myclass-dashboard-download-certificate-button-page",
  },
  modal: {
    closeButton: "modal-close-button",
    confirmButton: "button-confirm",
    confirmCancelButton: "cancel-confirmation-button",
  },
  certificateType: {
    rakamin: "rakamin-certificate",
    learningWithLR: "learning-with-lr-certificate",
  },
  confirmationModal: {
    confirmButton: "button-confirm",
    cancelButton: "cancel-confirmation-button",
    container: "confirmation-modal-container",
  },
  emailVerificationModal: {
    sendEmailButton: "send-email-button",
    verifyLater: "verifyLater",
  },
  aboutPBI: {
    titleHero: "about-pbi-title-hero",
    registerPBI: "about-pbi-register-button",
    tabMenuComparison: "about-pbi-page-tab-menu-comparison-button",
    menuComparisonCopy: "about-pbi-page-comparison-copy",
    readOtherTestimoniesButton: "about-pbi-read-other-testimonies-button",
    goToPBIProgramDetail: "about-pbi-go-to-program-detail",
  },
  jobApplication: {
    // general
    headerLogo: "job-list-header-logo",
    educationFilter: "job-list-education-filter",
    cityFilter: "job-list-city-filter",
    backToJobListButton: "apply-job-back-to-job-list-button",
    uploaderSubmitButton: "uploader-submit-button",
    thankyouTitle: "apply-job-thankyou",

    // job-detail sticky Apply CTA (public + logged-in)
    jobDetailApplyCta: "job-detail-apply-cta",
    // DCP-side Apply Vacancy card CTA
    dcpApplyCta: "dcp-apply-vacancy-cta",

    // form
    applyButton: "job-application-apply-button",
    confirmQuotaButton: "job-application-confirm-quota-button",
    fullNameField: "job-application-fullname-field",
    degreeField: "job-application-degree-field",
    majorField: "job-application-major-field",
    institutionField: "job-application-institution-field",
    gpaField: "job-application-gpa-field",
    universityStartField: "job-application-university-start-field",
    universityGraduateField: "job-application-university-graduate-field",
    expectedSalaryMinField: "job-application-expected-salary-min-field",
    expectedSalaryMaxField: "job-application-expected-salary-max-field",
    competenciesField: "job-application-competencies-field",
    dateOfBirthField: "job-application-date-of-birth-field",
    religionField: "job-application-religion-field",
    domicileField: "job-application-domicile-field",
    ethnicField: "job-application-ethnic-field",
    phoneNumberField: "job-application-phone-number-field",
    genderField: "job-application-gender-field",
    yearsOfExperienceField: "job-application-years-of-experience-field",
    roleField: "job-application-role-field",
    employmentTypeField: "job-application-employment-type-field",
    companyNameField: "job-application-company-name-field",
    industryField: "job-application-industry-field",
    experienceStartDateField: "job-application-experience-start-date-field",
    experienceEndDateField: "job-application-experience-end-date-field",
    submitFormButton: "job-application-submit-form-button",
    uploadCvField: "job-application-upload-cv-field",
    linkedinField: "job-application-linkedin-field",
    portfolioField: "job-application-portfolio-field",
    uploadPhotoField: "job-application-upload-photo-field",
    educationCertificateNumberField: "job-application-education-certificate-number-field",
    educationCertificateField: "job-application-education-certificate-field",
    cvField: "job-application-cv-field",
    ktpField: "job-application-ktp-field",
    ijazahField: "job-application-ijazah-field",
    loading: "job-application-loading-state",
    editIntro: "job-application-edit-intro",
    photoIntro: "job-application-photo-intro",
    photoIntroButton: "job-application-photo-intro-button",
    aboutEditButton: "job-application-about-edit-button",
    backToDataUploadButton: "job-application-back-to-data-upload-button",
    aboutField: "job-application-about-field",
    videoUrlField: "job-application-video-url-field",
    loadMore: "job-application-load-more",
  },
  companyLearningDashboard: {
    banner: "company-learning-dashboard-banner",
    competencyChart: "company-learning-dashboard-competency-chart",
    divisionChart: "company-learning-dashboard-division-chart",
    downloadInsightsButton: "company-learning-dashboard-download-button",
    loadMoreButton: "company-learning-dashboard-load-more-button",
  },
  identityVerification: {
    agreementCheckbox: "agreement-checkbox",
    continueButton: "continue-button",
    attachmentFile: "identity-attachment-file",
    uploadBox: "identity-upload-box",
  },
  customLanding: {
    registerButton: "custom-landing-regist-button",
    returnDashboardButton: "custom-landing-return-dashboard",
    logoutButton: "custom-landing-logout-button",
    loginButton: "custom-landing-login-button",
  },
  careerDashboard: {
    appliedVacancyCount: "career-dashboard-applied-vacancy-count",
    jobCard: "career-dashboard-job-card",
    jobCardSkeletons: "career-dashboard-job-card-skeletons",
    jobCardDetail: "career-dashboard-job-card-detail",
    jobCardExpandBtn: "career-dashboard-job-card-expand-btn",
    alert: "career-dashboard-alert",
    interviewInvitationModal: "career-dashboard-interview-modal",
    offeringInvitationModal: "career-dashboard-offering-modal",
    uploadOfferingDocument: "career-dashboard-upload-offering-document",
    medicalCheckupModal: "career-dashboard-medical-checkup-modal",
    checkEmailModal: "career-dashboard-check-email-modal",
    studyCaseModal: "career-dashboard-study-case-modal",
    uploadStudyCase: "career-dashboard-upload-study-case",
    successModal: "career-dashboard-success-modal",
  },
  talentPool: {
    jobVacancyDropdown: "talent-pool-job-vacancy-dropdown",
    searchField: "talent-pool-search-field",
    viewSavedTalent: "talent-pool-view-saved-talent-button",
    activateMatchMaking: "talent-pool-activate-match-making-button",
    categoryDropdown: "talent-pool-category-dropdown",
    inviteButton: "talent-pool-invite-button",
    bookmarkButton: "talent-pool-bookmark-button",
    viewProfileButton: "talent-pool-view-profile-button",
    loadMoreButton: "talent-pool-load-more-button",
    talentDetail: {
      title: "talent-pool-talent-detail-title",
      sendInvitationButton: "talent-pool-send-invitation-button",
      bookmarkButton: "talent-pool-talent-detail-bookmark-button",
    },
    modalInvite: {
      talentName: "talent-pool-modal-invite-talent-name",
    },
    talentCard: {
      name: "talent-pool-talent-card-name",
    },
  },
  helpCenter: {
    bannerButton: "help-center-banner-button",
    whatsapButton: "help-center-whatsapp-button",
  },
  uploader: {
    fileName: "uploader-file-name",
  },
};
